import { render, staticRenderFns } from "./register.vue?vue&type=template&id=13c757b9&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=13c757b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c757b9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FacebookButton: require('/var/www/jaty-frontend/components/FacebookButton.vue').default,InputsBackendErrors: require('/var/www/jaty-frontend/components/inputs/BackendErrors.vue').default,InputsInput: require('/var/www/jaty-frontend/components/inputs/Input.vue').default,AuthFormSecondaryLink: require('/var/www/jaty-frontend/components/AuthFormSecondaryLink.vue').default})
